import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ac63f4e")

_pushScopeId("data-v-8ac63f4e")
const _hoisted_1 = { class: "battle-list" }
const _hoisted_2 = { class: "battle-list-title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("em", { class: "icon-dot" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("em", { class: "icon-dot" }, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "battle-item-head" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = {
  key: 1,
  class: "battle-item"
}
const _hoisted_9 = { class: "no" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_like_btn_wrap = _resolveComponent("like-btn-wrap")!
  const _component_char_start_head = _resolveComponent("char-start-head")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.title) + " ", 1),
      _hoisted_4
    ]),
    (_ctx.hasData)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formatList, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "battle-item",
              key: item.key + index
            }, [
              _createVNode("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('battle')) + " " + _toDisplayString(index + 1), 1),
                _createVNode(_component_like_btn_wrap, {
                  class: "right",
                  initId: item.value[0].UUID,
                  initIsLike: item.value[0].IS_LIKE == 1,
                  initTotalNum: item.value[0].LIKE_TOTAL
                }, null, 8, ["initId", "initIsLike", "initTotalNum"])
              ]),
              _createVNode("div", {
                class: ["battle-item-main", _ctx.getBattleListClassName(item.value.length)]
              }, [
                _createVNode(_TransitionGroup, {
                  appear: "",
                  css: false,
                  onBeforeEnter: _ctx.beforeEnter,
                  onEnter: _ctx.enter,
                  onAfterEnter: _ctx.afterEnter
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (cItem, cIndex) => {
                      return (_openBlock(), _createBlock(_component_char_start_head, {
                        class: "head",
                        key: cItem.charInfo.id + cIndex,
                        "data-delay": index * 60,
                        id: cItem.charInfo.id,
                        name: cItem.charInfo.name,
                        rarity: cItem.charInfo.rarity,
                        category: cItem.charInfo.category,
                        isReal: cItem.STAR_NUM != 0,
                        ring: cItem.RINGS_POS,
                        ringDetail: cItem.ringDetail,
                        start: cItem.CARD_STAR_NUM,
                        charListImg: cItem.charInfo.charHeadImg
                      }, null, 8, ["data-delay", "id", "name", "rarity", "category", "isReal", "ring", "ringDetail", "start", "charListImg"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["onBeforeEnter", "onEnter", "onAfterEnter"])
              ], 2)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("p", _hoisted_9, _toDisplayString(_ctx.fromRole ? _ctx.$t('noBattleFromRole') : _ctx.$t('noBattle')), 1)
        ]))
  ]))
})